export default __webpack_public_path__ + "static/media/pic7.6834b951.jpg";